//region :: Imports ::
import React, {ReactElement} from 'react';
import {LogLevel} from '@azure/msal-browser';
import MComponent from '../Component';
import MAuthProvider from '../Auth/AuthProvider';

//endregion

/** */
type Props = {
    children: ReactElement;
}

/** */
class MAuthenticate extends MComponent<Props> {

    private readonly m_clientId: string;
    private readonly m_tenantId: string;
    private readonly m_logLevel: LogLevel;

    /** */
    public constructor(props: Props) {
        super(props);

        const logLevelSetting = process.env.REACT_APP_AUTH_LOGLEVEL;
        const logLevelKey = logLevelSetting === undefined || logLevelSetting.length === 0 ? LogLevel.Warning.toString() : logLevelSetting!;
        const logLevel = LogLevel[logLevelKey as keyof typeof LogLevel];

        this.m_clientId = process.env.REACT_APP_AUTH_CLIENTID!;
        this.m_tenantId = process.env.REACT_APP_AUTH_TENANTID!;
        this.m_logLevel = logLevel;

    }

    /** */
    public render(): ReactElement {

        return (
            <MAuthProvider clientId={this.m_clientId}
                           tenantId={this.m_tenantId}
                           logLevel={this.m_logLevel}>

                {this.props.children}

            </MAuthProvider>
        );

    }

}

export default MAuthenticate;
